import React from 'react';
import priceFormatter from '@upgrade/ui-utils/formatters/price';
import { Column, Row } from '@upgrade/react-components';
import { Bar, StyledBarContainer, StyledChartContainer, StyledSavingsText } from './styles';
import { getYearsLabel } from '../../../utils/strings';
import { Text } from '../../common/TypographyPublicSite';

const NUMBER_OF_BARS = 5;

export const calculateInterestSaved = (amount, years, apy) => {
  const totalSavings = amount * (1 + apy / 100) ** years;
  const interestSaved = totalSavings - amount;
  return Math.floor(interestSaved);
};

const SavingsChart = ({ initialDeposit, years, apy, totalInterestSaved }) => {
  if (!initialDeposit || !years || !apy || !totalInterestSaved) {
    return null;
  }

  const bars = [];
  for (let i = 0; i < NUMBER_OF_BARS; i += 1) {
    const barYears = (years / NUMBER_OF_BARS) * (i + 1);
    const interestSaved = calculateInterestSaved(initialDeposit, barYears, apy);
    bars.push({ interestSaved, label: getYearsLabel(barYears) });
  }

  return (
    <StyledChartContainer>
      <Row>
        {bars.map(bar => {
          const savingsPercentage = Math.floor((bar.interestSaved / totalInterestSaved) * 100);
          return (
            <Column xs xsHorizontalAlign="center">
              <StyledBarContainer>
                <Bar $height={savingsPercentage}>
                  <StyledSavingsText size="md" bold>
                    {priceFormatter(bar.interestSaved, { digits: 0 })}
                  </StyledSavingsText>
                </Bar>
              </StyledBarContainer>
              <Text size="md" color="contentWeak" as="p">
                {bar.label}
              </Text>
            </Column>
          );
        })}
      </Row>
    </StyledChartContainer>
  );
};

export default SavingsChart;
